var separatorMatcher = () => {
  // no suggestions
  return null;
};
export { separatorMatcher as default };
